define("shared/utils/formatters/format-media-engagement-from-dynamo", ["exports", "@ember/utils"], function (_exports, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils"eaimeta@70e063a35619d71f
  /**
   * Formats a single media's engagement data from dynamo
   * Will combine carousel engagement values with non-carousel ones.
   *
   * @method formatMediaEngagementFromDynamo
   * @param {MediaEngagementPointRaw} engagement A single media's engagement data from dynamo
   *
   * @returns {FormattedDynamoMediaEngagement} Returns a formatted version of a media's engagement data
   */
  function formatMediaEngagementFromDynamo(engagement) {
    return Object.assign({}, engagement, {
      impressions: (0, _utils.isPresent)(engagement.impressions) ? engagement.impressions : engagement.carousel_album_impressions,
      views: (0, _utils.isPresent)(engagement.views) ? engagement.views : engagement.carousel_album_views,
      reach: (0, _utils.isPresent)(engagement.reach) ? engagement.reach : engagement.carousel_album_reach,
      saved: (0, _utils.isPresent)(engagement.saved) ? engagement.saved : engagement.carousel_album_saved,
      video_views: engagement.total_plays || engagement.carousel_album_video_views,
      engagement: (0, _utils.isPresent)(engagement.engagement) ? engagement.engagement : engagement.carousel_album_engagement
    });
  }
  var _default = _exports.default = formatMediaEngagementFromDynamo;
});